// Country for address
export interface ICountry {
  id: number;
  code: string;
  name: string;
  status: string;
  alpha2: string;
  alpha3: string;
  numeric: string;
  isDefault?: boolean;
  defaultCurrencyId?: number;
  createdAt?: string;
  updatedAt?: string;
}
